<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { todoComputed, todoMethods } from '@/state/helpers'
// import jwt_decode from 'jwt-decode'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'
import $store from '@/state/store'

/**
 * Starter component
 */
export default {
  page: {
    title: 'QC Perangkat',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      // isShow : false
      iconHourGlassSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 16 16">
                  <path fill="currentColor" d="M11.39 8C13.542 6.635 15 4.012 15 1q0-.508-.054-1H1.055a9 9 0 0 0-.054 1c0 3.012 1.457 5.635 3.609 7c-2.152 1.365-3.609 3.988-3.609 7q0 .508.054 1h13.891q.054-.492.054-1c0-3.012-1.457-5.635-3.609-7zM2.5 15c0-2.921 1.253-5.397 3.5-6.214V7.214C3.753 6.397 2.5 3.92 2.5 1h11c0 2.921-1.253 5.397-3.5 6.214v1.572c2.247.817 3.5 3.294 3.5 6.214zm7.182-4.538C8.562 9.827 8.501 9.003 8.5 8.503V7.499c0-.5.059-1.327 1.184-1.963c.602-.349 1.122-.88 1.516-1.537H4.8c.395.657.916 1.188 1.518 1.538c1.12.635 1.181 1.459 1.182 1.959V8.5c0 .5-.059 1.327-1.184 1.963c-1.135.659-1.98 1.964-2.236 3.537h7.839c-.256-1.574-1.102-2.879-2.238-3.538z"></path>
                </svg>`,
    }
  },
  computed: {
    ...todoComputed,
    // ...Helper,
    /**
     * Total no. of records
     */
    title() {
      return this.$t('qcdevice.dataMaster')
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    flagLogHistory() {
      return $store.state.config.logHistory
    },
  },
  mixins: [Helper],
  methods: {
    ...todoMethods,
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ $t('qcdevice.dataMaster') }}</span>
            </template>
            <b-row class="mc-card__list">
              <!-- Registrasi Perangkat -->
              <b-col
                v-if="
                  this.getAccessRight('qcDevice') ||
                  hasAccess([
                    'sms-device-register:create',
                    'sms-device-register:read',
                    'sms-device-register:update',
                    'sms-device-register:delete',
                  ])
                "
                md="6"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Register Device' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_save"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('qcdevice.registerDevice') }}</h4>
                    <p>{{ $t('qcdevice.textDevice') }}</p>
                  </div>
                </b-button>
              </b-col>

              <!-- Pengaturan Perangkat -->
              <b-col
                v-if="
                  this.getAccessRight('qcDevice') ||
                  hasAccess([
                    'sms-device-setting:create',
                    'sms-device-setting:read',
                    'sms-device-setting:update',
                    'sms-device-setting:delete',
                  ])
                "
                md="6"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Device' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_settings"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.list.setDevice') }}</h4>
                    <p>{{ $t('setting.list.textSetdevice') }}</p>
                  </div>
                </b-button>
              </b-col>

              <!-- Online Command -->
              <b-col
                md="6"
                v-if="
                  hasAccess([
                    'sms-device-setting:create',
                    'sms-device-setting:read',
                    'sms-device-setting:update',
                    'sms-device-setting:delete',
                  ])
                "
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Bulk Online Command' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_code-download"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('qcdevice.bulkOnlineCommand.title') }}</h4>
                    <p>{{ $t('qcdevice.bulkOnlineCommand.description') }}</p>
                  </div>
                </b-button>
              </b-col>

              <!-- SMS Gateway -->
              <b-col md="6" v-if="hasAccess(['sms-websocket:create'])">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'SMS Gateway' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_smartphone"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('qcdevice.smsGateway.title') }}</h4>
                    <p>{{ $t('qcdevice.smsGateway.description') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col v-if="this.getAccessRight('qcDevice') || hasAccess(['rfid:read'])" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Register RFID' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_save"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('qcdevice.registerRfid') }}</h4>
                    <p>{{ $t('qcdevice.registerRfidText') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col
                v-if="
                  flagLogHistory &&
                  (this.getAccessRight('qcDevice') || hasAccess(['log_activity:read']))
                "
                md="6"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Log History' })"
                  class="d-block w-100 mc-card__list-item clearfix d-flex align-items-center"
                >
                  <!-- Flex container for the icon and content -->
                  <div class="d-flex align-items-center w-100">
                    <!-- Icon on the left -->
                    <div v-html="iconHourGlassSvg" class="force-icon-margin"></div>

                    <!-- Content next to the icon -->
                    <div class="mc-card__list-item-content">
                      <h4>Log History</h4>
                      <p>Mencatat histori perubahan dalam sistem</p>
                    </div>
                  </div>
                </b-button>
              </b-col>

              <b-col v-if="this.getAccessRight('qcDevice') || hasAccess(['ibeacon:read'])" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Register Ibeacon' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_save"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('qcdevice.registerIbeacon') }}</h4>
                    <p>{{ $t('qcdevice.registerIbeaconText') }}</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-cog"></i>
              </span>
              <span class="d-none d-sm-inline-block">General Settings</span>
            </template>
            <b-row class="mc-card__list">
              <b-col
                v-if="this.getAccessRight('qcDevice') || hasAccess(['custom-interval:read'])"
                md="6"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Custom Interval' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_settings"></i>

                  <div class="mc-card__list-item-content">
                    <h4>Custom Interval</h4>
                    <p>Mengelola pengaturan secara general</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                v-if="this.getAccessRight('qcDevice') || hasAccess(['sms-vss-configuration:read'])"
                md="6"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Vss Configuration' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_settings"></i>

                  <div class="mc-card__list-item-content">
                    <h4>Profile ADAS & DMS</h4>
                    <p>Mengelola preset adas dan dms howen</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                v-if="
                  this.getAccessRight('qcDevice') ||
                  hasAccess(['sms-device-camera:read'])
                "
                md="6"
                >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Camera Configuration' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_settings"></i>

                  <div class="mc-card__list-item-content">
                    <h4>Konfigurasi Camera</h4>
                    <p>Mengelola konfigurasi kamera pada tipe device</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                v-if="this.getAccessRight('qcDevice') || hasAccess(['sms-error-description:read'])"
                md="6"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Error Description' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_info"></i>

                  <div class="mc-card__list-item-content">
                    <h4>Error Description</h4>
                    <p>Mengelola daftar kode error dan pesan</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>

<!-- temporary should be removed in the future -->
<style scoped>
.force-icon-margin {
  margin-right: -30px;
  margin-left: 4px;
}
</style>
